import { render, staticRenderFns } from "./HomeDisplay.vue?vue&type=template&id=485789b0&scoped=true&"
import script from "./HomeDisplay.vue?vue&type=script&lang=js&"
export * from "./HomeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./HomeDisplay.vue?vue&type=style&index=0&id=485789b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485789b0",
  null
  
)

export default component.exports